import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import Reports from "./index";
import ViewReport from "./view";
import EditReport from "./edit";
import { MODULE_REPORTS } from "variables/constants";
import { FileChartColumnIncreasing } from "lucide-react";


const reportsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Reports",
		basePath: "reports",
		mainComponent: <Reports />,
	    layout: "/console",	   
	    icon: <FileChartColumnIncreasing className="icon-item" />,
	    subTitle:"Report",
	    viewComponent: <ViewReport />,
	    createComponent: <EditReport />,
	    editComponent: <EditReport />,
		level:4,
		moduleId: MODULE_REPORTS,
	})
]

export default reportsRoutes;